import React from 'react';
import { Box, VStack, Flex, Circle, Skeleton } from '@chakra-ui/react';

function LoadingSkeleton() {
  return (
    <Box
      position="absolute"
      bottom="10%"
      right="20px"
      zIndex={9999}
      bg="white"
      borderRadius="16px"
      boxShadow="0 8px 32px rgba(0, 0, 0, 0.12)"
      border="1px solid"
      borderColor="gray.100"
      minWidth="320px"
      maxWidth="320px"
      maxHeight="500px"
    >
      {/* Header Skeleton */}
      <Flex justify="space-between" align="center" p="16px" borderBottom="1px solid" borderColor="gray.100">
        <VStack align="start" spacing="4px">
          <Skeleton height="16px" width="120px" />
          <Skeleton height="12px" width="180px" />
        </VStack>
        <Skeleton height="24px" width="24px" borderRadius="50%" />
      </Flex>

      {/* Content Skeleton */}
      <Box p="16px">
        <VStack spacing="16px">
          {/* Timer Skeleton */}
          <Flex justify="center" align="center" py="40px">
            <VStack spacing="8px">
              <Skeleton height="48px" width="120px" />
              <Skeleton height="14px" width="100px" />
            </VStack>
          </Flex>

          {/* Recording Button Skeleton */}
          <Flex justify="center" align="center" pb="40px">
            <Circle size="70px">
              <Skeleton height="70px" width="100px" borderRadius="50%" />
            </Circle>
          </Flex>
        </VStack>
      </Box>

      {/* Toggle Button Skeleton */}
      <Flex justify="center" p="8px" paddingBottom="50px">
        <Skeleton height="32px" width="80px" borderRadius="16px" />
      </Flex>
    </Box>
  );
}

export { LoadingSkeleton };
